import { useTranslation } from "react-i18next";
import parse from 'html-react-parser';

export function IntroMessage () {
    const { t } = useTranslation();

    return(
        <div className="intro-message box">
            <h2>{ parse(t("What is <span>taskGen</span>?")) }</h2>
            <div className="message">
                <p>{ t("It is an ongoing three-year research project made possible by a grant PID2023-149648NB-I00 funded by the Ministry of Science and Innovation (MCIN) and National Research Agency (AEI) 10.13039/501100011033.") } </p>
                <p>{ t("In this project we are developing and piloting a tool that will help teachers and task and syllabus designers with organizing and automating the design of second/foreign language communicative tasks. If you wish to know more about the project, please click here...") } <a href="https://taskgenresearchgroup.wordpress.com/" title={ t("Read more") }>{ t("Read more") }</a></p>
            </div>
        </div>
    )
}
